import tmdbRequestQueue from '../services/tmdbRequestQueue';

/**
 * Warms the shared TMDB queue cache (memory → Firestore → TMDB) before navigation to Movie detail.
 * Safe to call on every tap; deduped inside the queue. Helps fallback path and revisits when Functions is slow.
 */
export function prefetchMovieDetailClient(movieId: string | undefined | null): void {
  if (!movieId || movieId === 'unknown') return;
  void tmdbRequestQueue.getMovieData(movieId).catch(() => {
    /* best-effort */
  });
}
